import '@babel/polyfill'
import 'mutationobserver-shim'
/* eslint-disable */
import App from './App.vue';
import store from './store'
import axios from 'axios'
import i18n from "@/plugins/i18n";
import router from "@/router";
import Vue from "vue";

import '../src/assets/fz.css'

import moment from 'moment'
Vue.prototype.$moment = moment

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './plugins/bootstrap-vue'


// Vue.use(router)

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

